module.exports = __webpack_public_path__ + "img/application-empty-state.fe3e952c.svg";